module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/2/2-fb972c31b19dd4caa6dbe5093bbe8434.jpg";